// extracted by mini-css-extract-plugin
export default {"container":"M41F8I","divider":"BWcPdK"};